var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#F3F3F3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    stroke: "#F3F3F3",
    strokeWidth: 0.5,
    d: "M18.723 9.277c-.37-.37-.968-.37-1.338 0L14 12.662l-3.385-3.385c-.37-.37-.968-.37-1.337 0-.37.37-.37.969 0 1.338L12.662 14l-3.385 3.385c-.37.37-.37.968 0 1.338.185.184.427.277.669.277.242 0 .484-.093.669-.277L14 15.337l3.385 3.386c.185.185.427.277.669.277.242 0 .484-.092.669-.277.37-.37.37-.969 0-1.338L15.338 14l3.385-3.385c.37-.37.37-.968 0-1.338z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.f22c5e0c9e5bebb44f73fb6f6eda3d52.svg";
export { ForwardRef as ReactComponent };